// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .p-sidebar-footer {
  padding: 0 !important;
}
:host ::ng-deep .p-menuitem-icon {
  min-width: 16px;
}
:host ::ng-deep .p-sidebar-content {
  padding-inline: 0 !important;
  padding-top: 0 !important;
}
:host ::ng-deep .p-button-icon {
  min-width: 14px;
}
:host ::ng-deep #profile-menu .p-submenu-list {
  right: 0;
  min-width: 235px;
}

.profile-dropdown-container .profile-dropdown a {
  min-width: 54px;
}

.header-banner {
  position: absolute;
  top: 100%;
  left: 50%;
  translate: -50% 0;
  text-align: center;
  background: white;
  color: black;
  max-width: -moz-fit-content;
  max-width: fit-content;
  padding-left: 2rem;
  padding-right: 1rem;
  margin-inline: auto;
  border-radius: 0 0 16px 16px;
  box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.3);
}
.header-banner p {
  margin-block: 0;
}
@media only screen and (max-width: 1199px) {
  .header-banner {
    max-width: 100vw;
    width: calc(100vw - 2rem);
    line-height: 1;
    padding-inline: 1rem;
  }
  .header-banner p {
    gap: 0.5rem;
  }
  .header-banner span:last-child {
    position: absolute;
    top: 0;
    right: 0;
    padding: 1rem;
  }
}

.header-banner-closed .header-banner {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/app/core/components/header/header.component.scss"],"names":[],"mappings":"AAOE;EACE,qBAAA;AANJ;AASE;EACE,eAAA;AAPJ;AAUE;EACE,4BAAA;EACA,yBAAA;AARJ;AAWE;EACE,eAAA;AATJ;AAYE;EACE,QAAA;EACA,gBAAA;AAVJ;;AAcA;EACE,eAAA;AAXF;;AAcA;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,2BAAA;EAAA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,4BAAA;EACA,yCAAA;AAXF;AAaE;EACE,eAAA;AAXJ;AAtCE;EAiCF;IAoBI,gBAAA;IACA,yBAAA;IACA,cAAA;IACA,oBAAA;EAXF;EAaE;IACE,WAAA;EAXJ;EAcE;IACE,kBAAA;IACA,MAAA;IACA,QAAA;IACA,aAAA;EAZJ;AACF;;AAgBA;EACE,aAAA;AAbF","sourcesContent":["@mixin md() {\r\n  @media only screen and (max-width: 1199px) {\r\n    @content;\r\n  }\r\n}\r\n\r\n:host ::ng-deep {\r\n  .p-sidebar-footer {\r\n    padding: 0 !important;\r\n  }\r\n\r\n  .p-menuitem-icon {\r\n    min-width: 16px;\r\n  }\r\n\r\n  .p-sidebar-content {\r\n    padding-inline: 0 !important;\r\n    padding-top: 0 !important;\r\n  }\r\n\r\n  .p-button-icon {\r\n    min-width: 14px;\r\n  }\r\n\r\n  #profile-menu .p-submenu-list {\r\n    right: 0;\r\n    min-width: 235px;\r\n  }\r\n}\r\n\r\n.profile-dropdown-container .profile-dropdown a {\r\n  min-width: 54px;\r\n}\r\n\r\n.header-banner {\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 50%;\r\n  translate: -50% 0;\r\n  text-align: center;\r\n  background: white;\r\n  color: black;\r\n  max-width: fit-content;\r\n  padding-left: 2rem;\r\n  padding-right: 1rem;\r\n  margin-inline: auto;\r\n  border-radius: 0 0 16px 16px;\r\n  box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.3);\r\n\r\n  p {\r\n    margin-block: 0;\r\n  }\r\n\r\n  @include md() {\r\n    max-width: 100vw;\r\n    width: calc(100vw - 2rem);\r\n    line-height: 1;\r\n    padding-inline: 1rem;\r\n\r\n    p {\r\n      gap: 0.5rem;\r\n    }\r\n\r\n    span:last-child {\r\n      position: absolute;\r\n      top: 0;\r\n      right: 0;\r\n      padding: 1rem;\r\n    }\r\n  }\r\n}\r\n\r\n.header-banner-closed .header-banner {\r\n  display: none\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
